import "core-js/modules/es6.symbol.js";
import "core-js/modules/es7.array.flat-map.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// eslint-disable-next-line
import { fromPromise, concat } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { createUploadLink } from 'apollo-upload-client';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import schema from './apollo-schema.json';
import USE_MARKETPLACE from '~/const/marketplace';
import logout from '~/helpers/logout-helper';
import refreshAppShopTokenQuery from '~/graphql/refreshAppShop.gql';
var fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: schema
});
export default function (_ref) {
  var {
    store,
    req,
    app
  } = _ref;
  var {
    header = {}
  } = req || {};
  var {
    graphqlExternal,
    graphqlInternal,
    graphqlShopInternal,
    graphqlShopExternal,
    appShopUrl
  } = store.getters['sharedEnv/getSharedEnv'];
  var locale = store.getters['i18n/locale'];
  var useCatalogv1 = store.$cookies.get('usecatalogv1');
  var useStsAuth = 1; // store.$cookies.get('useStsAuth');

  var displayMkpProducts = USE_MARKETPLACE({
    locale,
    $cookies: store.$cookies
  });
  var shop = store.$cookies.get('MDM_TOGGLE_SHOP');
  var httpEndpoint = process.browser ? graphqlExternal : graphqlInternal;
  if (shop) httpEndpoint = process.browser ? graphqlShopExternal : graphqlShopInternal;
  var xMdM = Object.entries(header).filter((_ref2) => {
    var [key] = _ref2;
    return /^x-mdm-/i.test(key);
  }).reduce((acc, _ref3) => {
    var [key, value] = _ref3;
    acc[key] = value;
    return acc;
  }, {});
  var httpLink = createUploadLink({
    uri: httpEndpoint,
    credentials: 'include',
    headers: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, xMdM), header['correlation-id'] && {
      'correlation-id': header['correlation-id']
    }), header['mdm-client-ip'] && {
      'mdm-client-ip': header['mdm-client-ip']
    }), {
      'Ws-Cat-Version': useCatalogv1 ? 1 : 2
    }), displayMkpProducts && {
      'Source-Mkp-Products': 1
    }), useStsAuth && {
      'sts-auth': 1
    }), {}, {
      'Accept-Language': locale.iso
    })
  });
  var isRefreshing = false;
  var pendingRequests = [];

  var resolvePendingRequests = () => {
    pendingRequests.map(callback => callback());
    pendingRequests = [];
  };

  var errorLink = onError((_ref4) => {
    var {
      graphQLErrors,
      operation,
      forward
    } = _ref4;

    if (graphQLErrors && graphQLErrors.some((_ref5) => {
      var {
        extensions
      } = _ref5;
      return extensions.code === 'UNAUTHENTICATED_EMPLOYEE';
    })) {
      if (isRefreshing) {
        return fromPromise(new Promise(resolve => {
          pendingRequests.push(() => resolve());
        })).flatMap(() => forward(operation));
      }

      isRefreshing = true;
      return fromPromise(app.apolloProvider.defaultClient.mutate({
        mutation: refreshAppShopTokenQuery
      }).then(() => {
        if (!store.$cookies.get('MDM_SELLER_TOKEN')) {
          throw new Error('Failed to refresh seller access token.');
        }

        resolvePendingRequests();
        isRefreshing = false;
        return true;
      }).catch(err => {
        console.log(err);
        pendingRequests = [];
        logout();
        window.location.href = "".concat(appShopUrl, "?sessionExpired=true");
      })).filter(value => Boolean(value)).flatMap(() => forward(operation));
    }

    return null;
  });
  return {
    link: concat(errorLink, httpLink),
    cache: new InMemoryCache({
      fragmentMatcher
    }),
    defaultHttpLink: false
  };
}